export default function handleFooter() {

    const root                  = document.documentElement;
    const animatedPhrases       = document.querySelector('.animated-phrases');

    if (!animatedPhrases) {
        return;
    }

    const animatedPhrasesHeight = animatedPhrases.offsetHeight;

    root.style.setProperty('--animated-phrases-height', animatedPhrasesHeight + 'px');

}
